<template>
  <div class="contain">
    <!-- 검색 조건 -->
    <div class="search_form" ref="search_form">
      <el-form
        :inline="true"
        :model="searchForm"
        :label-position="$device.large ? `top` : `left`"
        :label-width="$device.tablet ? `` : `100px`"
        label-suffix=":"
        :size="size"
        @submit.native.prevent>
        <el-row>
          <el-col :md="12">
            <el-form-item :label="$t('기간')">
              <el-date-picker
                v-model="sedtm"
                type="datetimerange"
                unlink-panels
                :style="{ width: $device.mobile ? `100%` : `300px` }"
                :default-time="['06:00:00', '23:00:00']"
                :start-placeholder="$t('날자 선택')"
                :end-placeholder="$t('날자 선택')"
                value-format="yyyy-MM-dd HH:mm:ss"></el-date-picker>

              <el-checkbox
                v-model="searchForm.autoEdtm"
                :label="$t('마감 시간 자동 갱신')"
                style="margin-left: 10px"></el-checkbox>
            </el-form-item>
          </el-col>
          <el-col :md="12">
            <el-form-item :label="$t('주문 취소 여부')">
              <!--
                「환불 실패만」이면 취소 축은 서버 술어가 정한다(`utils/orderRefund.orderListQuery`) — 셀렉트는 잠근다. 같은 줄에 둔다:
                검색 영역이 한 줄 늘면 이 화면의 표 높이가 그만큼 줄어든다.
              -->
              <combo
                :data="mainVue.code.cancelYn"
                :model="searchForm.cancelYn"
                :disabled="searchForm.refundPending"
                :style="{ width: $device.mobile ? `` : `160px` }"
                @change="searchForm.cancelYn = $event"></combo>
              <el-checkbox
                v-model="searchForm.refundPending"
                data-testid="refund-pending-only"
                class="order-list__refund"
                >{{ $t(refundText.refundPendingOnly) }}</el-checkbox
              >
            </el-form-item>
          </el-col>
          <el-col :md="12">
            <el-form-item :label="$t('주문 상태')">
              <mcode-combo
                :data="orderStatus"
                :model="orderStatusCds"
                @change="orderStatusCds = $event"
                :style="{ width: $device.mobile ? `` : `400px` }"></mcode-combo>
            </el-form-item>
          </el-col>
          <el-col :md="12">
            <TableFieldCombo />
          </el-col>
        </el-row>
      </el-form>
    </div>

    <!-- 버튼-->
    <div class="buttons" ref="buttons">
      <el-button
        v-if="checkAuthActionAccess('OrderForStoreSearch')"
        :size="size"
        @click="searchWithPeriod"
        icon="el-icon-search"
        >{{ $t('검색') }}</el-button
      >
      <el-button v-if="checkAuthActionAccess('OrderForStoreSearch')" :size="size" @click="handleExpand">{{
        !expand ? this.$t('보기') : this.$t('접기')
      }}</el-button>
      <el-switch
        v-model="autoSearch"
        :active-text="$t('주문통지 시 자동 새로 검색')"
        style="margin-left: 30px"></el-switch>
    </div>

    <!-- 리스트 -->
    <el-table
      :height="tableHeight - 48"
      border
      stripe
      highlight-current-row
      tooltip-effect="dark"
      ref="table"
      :data="tableData"
      :size="size"
      :empty-text="$t('데이타 없음')"
      @row-click="handleRowClick"
      @row-dblclick="handleRowDbClick"
      @select="handleRowChecked"
      @select-all="handleRowChecked"
      @sort-change="handleSortChange"
      row-key="orderCd"
      :default-expand-all="expand">
      <el-table-column
        :label="totalElements.toString()"
        type="index"
        width="55"
        align="center"
        label-class-name="data_cnt"
        :index="indexMethod"></el-table-column>
      <el-table-column type="selection" width="45" align="center"></el-table-column>
      <el-table-column type="expand">
        <template slot-scope="props">
          <template v-for="item in props.row.smenus">
            <el-card :key="item.orderId" shadow="hover">
              <div slot="header">
                <el-row>
                  <el-col
                    :span="6"
                    v-if="
                      props.row.orderId.indexOf('S') == 0 ||
                      props.row.orderId.indexOf('P') == 0 ||
                      props.row.orderId.indexOf('D') == 0
                    "
                    >{{ item.category.categoryNmLan }}</el-col
                  >
                  <el-col :span="6">{{ item.smenuNmLan }}</el-col>
                  <el-col :span="6" class="el-col-num">{{ mainVue.formatterNum(null, null, item.price, null) }}</el-col>
                  <el-col :span="6" class="el-col-num">{{ item.cnt }}</el-col>
                </el-row>

                <el-row
                  v-for="discount in item.discounts"
                  :key="`${discount.discountNmLan}${discount.price}`"
                  style="margin-top: 5px">
                  <el-col :span="6">&nbsp;</el-col>
                  <el-col :span="6">{{ discount.discountNmLan }}</el-col>
                  <el-col :span="6" class="el-col-num"
                    >{{ 'price' == discount.discountTp.val ? discount.price : discount.percente + '%' }}
                  </el-col>
                </el-row>
              </div>

              <el-row v-for="opt in item.smenuOpts" :key="opt.smenuOptNmLan" style="margin-bottom: 5px">
                <el-col
                  :span="6"
                  v-if="
                    props.row.orderId.indexOf('S') == 0 ||
                    props.row.orderId.indexOf('P') == 0 ||
                    props.row.orderId.indexOf('D') == 0
                  "
                  >&nbsp;</el-col
                >
                <el-col :span="6">{{ opt.smenuOptNmLan }}</el-col>
                <el-col :span="6" class="el-col-num">{{ mainVue.formatterNum(null, null, opt.price, null) }}</el-col>
                <el-col :span="6" class="el-col-num">{{ opt.cnt * item.cnt }}</el-col>
              </el-row>
            </el-card>
          </template>
        </template>
      </el-table-column>

      <el-table-column
        :label="$t('알림톡')"
        align="center"
        width="90"
        v-if="'true' == mainVue.alarmYn || mainVue.alarmYn">
        <template slot-scope="scope">
          <div v-if="scope.row.cancelYn == 'N' && 'READY' == scope.row.orderStatus.val">
            <el-button size="mini" type="success" @click="send(scope.row.orderCd, scope.row.orderSeq)">{{
              $t('전송')
            }}</el-button>
          </div>
        </template>
      </el-table-column>

      <!--
				주문 -> 접수 -> 주방접수 -> 준비완료 -> 배달중 -> 배달완료
주문 -> 접수 -> 주방접수(있을수도 있고 없을수도 있고) -> 준비완료 -> 픽업완료 (포장 주문 시 )
주문 -> 접수 -> 주방접수(y/n) -> 준비완료 -> 배달중 -> 배달완료 (배달 주문 시)
				 -->
      <el-table-column :label="$t('상태 변경')" align="center" width="110">
        <template slot-scope="scope">
          <div v-if="scope.row.cancelYn == 'N'">
            <!-- 앱 주문 배달 이면서 결제 안된거면 상태변경 안됨 -->
            <div v-if="'N' == scope.row.payYn && null != scope.row.appUser">
              <span>{{ $t('미결제') }}</span>
            </div>

            <div v-else>
              <el-button
                size="mini"
                type="primary"
                @click="changeOrderStatus(scope.row, 'RECEIPT')"
                v-if="'ORDER' == scope.row.orderStatus.val"
                >{{ $t('접수') }}</el-button
              >

              <el-button
                size="mini"
                type="success"
                @click="changeOrderStatus(scope.row, 'READY')"
                v-if="'RECEIPT' == scope.row.orderStatus.val"
                >{{ $t('준비완료') }}</el-button
              >

              <el-button
                size="mini"
                type="warning"
                @click="changeOrderStatus(scope.row, 'OVER')"
                v-if="'READY' == scope.row.orderStatus.val && scope.row.salesTp.val != 'Delivery'"
                >{{ $t('완료') }}</el-button
              >

              <el-button
                size="mini"
                type="success"
                @click="changeOrderStatus(scope.row, 'DELIVERY')"
                v-if="'READY' == scope.row.orderStatus.val && scope.row.salesTp.val == 'Delivery'"
                >{{ $t('배달중') }}</el-button
              >

              <el-button
                size="mini"
                type="warning"
                @click="changeOrderStatus(scope.row, 'OVER')"
                v-if="'DELIVERY' == scope.row.orderStatus.val && scope.row.salesTp.val == 'Delivery'"
                >{{ $t('완료') }}</el-button
              >

              <span v-if="'OVER' == scope.row.orderStatus.val">{{ $t('주문 완료') }}</span>
            </div>
          </div>
        </template>
      </el-table-column>

      <!--
        주문 취소 — 완료 주문만 뺀다. 배달대행을 부른 주문(`orderDelivery`)도 취소할 수 있다: 서버가 주문을 취소하며 진행 중인
        배달대행 호출도 함께 취소하고, 그 결과를 응답에 실어 [del] 이 보인다(결정 2 — `utils/orderRefund.deliveryCallCancelNotice`).
      -->
      <el-table-column :label="$t('주문 취소')" align="center" width="110">
        <template slot-scope="scope">
          <div v-if="'OVER' != scope.row.orderStatus.val">
            <el-button
              size="mini"
              type="info"
              @click="del(scope.row.orderCd, scope.row.orderSeq)"
              v-if="scope.row.cancelYn == 'N'"
              >{{ $t('주문 취소') }}</el-button
            >
            <span v-else>{{ $t('주문 취소 됨') }}</span>
          </div>
        </template>
      </el-table-column>

      <!--
        취소·환불 — 받은 행에 취소된 주문이 있을 때만 그린다(`utils/orderRefund.hasCancelledRow`). 말은 그 모듈 한 곳이다:
        취소 주체(자동 취소·결제사 취소·계정 ID) · 취소 시각(서버 정렬 축 `cancelDate`) · 환불 상태(`PENDING` 강조).
      -->
      <el-table-column v-if="showsCancelColumns" :label="$t(refundText.cancelActor)" min-width="130" align="center">
        <template slot-scope="scope">
          <span data-testid="cancel-actor">{{ $t(cancelActorLabel(scope.row.cancelActor)) }}</span>
        </template>
      </el-table-column>
      <el-table-column
        v-if="showsCancelColumns"
        :label="$t(refundText.cancelDate)"
        prop="cancelDate"
        min-width="140"
        align="center"
        sortable="custom"></el-table-column>
      <el-table-column v-if="showsCancelColumns" :label="$t(refundText.refundStatus)" min-width="170" align="center">
        <template slot-scope="scope">
          <OrderRefundStatus :status="scope.row.refundStatus" :fail-reason="scope.row.cancelPayFailReason" />
        </template>
      </el-table-column>

      <el-table-column
        v-if="checkShouldTableColumnShow('deliveryAgencyRequested')"
        :label="$t('배달대행 요청')"
        align="center"
        width="110">
        <template slot-scope="scope">
          <div
            v-if="
              'Delivery' == scope.row.salesTp.val && 'READY' == scope.row.orderStatus.val && scope.row.cancelYn == 'N'
            ">
            <el-button size="mini" type="primary" @click="delivery(scope.row)">{{ $t('배달 요청') }}</el-button>
          </div>
          <div
            v-if="
              'Delivery' == scope.row.salesTp.val &&
              'DELIVERY' == scope.row.orderStatus.val &&
              scope.row.cancelYn == 'N'
            ">
            <el-button size="mini" type="success" @click="delivery(scope.row)">{{ $t('배달 변경') }}</el-button>
          </div>
        </template>
      </el-table-column>

      <el-table-column
        v-if="checkShouldTableColumnShow('deliveryStatus')"
        :label="$t('배달 상태')"
        min-width="110"
        align="center">
        <template slot-scope="scope">
          <div
            v-if="
              'Delivery' == scope.row.salesTp.val &&
              ('READY' == scope.row.orderStatus.val || 'DELIVERY' == scope.row.orderStatus.val) &&
              scope.row.cancelYn == 'N'
            ">
            {{ showDeliveryStatus(scope.row.orderDelivery) }}
          </div>
        </template>
      </el-table-column>

      <!-- 정렬은 **서버**가 한다(`sortable="custom"`) — 페이징된 목록에서 `sortable` 은 「이 페이지 안에서만」이라
           사람이 본 순서와 서버가 고른 한 장이 서로 다른 말을 한다. 중첩 값을 그리는 열(`salesTp.nmLan`·
           `orderStatus.nmLan`)의 `prop` 은 화면의 어휘이므로 [sortAliases] 가 서버의 컬럼 이름으로 옮긴다 -->
      <el-table-column
        v-if="checkShouldTableColumnShow('orderNo')"
        :label="$t('주문 번호')"
        prop="orderNo"
        min-width="110"
        align="center"
        sortable="custom"></el-table-column>
      <el-table-column
        v-if="checkShouldTableColumnShow('tableId')"
        :label="$t('테이블 번호')"
        prop="tableId"
        min-width="90"
        align="center"
        sortable="custom"></el-table-column>
      <el-table-column
        v-if="checkShouldTableColumnShow('orderDate')"
        :label="$t('주문 시간')"
        prop="orderDate"
        min-width="140"
        align="center"
        sortable="custom"></el-table-column>
      <el-table-column
        v-if="checkShouldTableColumnShow('orderAddr')"
        :label="$t('주소')"
        prop="orderAddr"
        min-width="200"
        show-overflow-tooltip></el-table-column>
      <el-table-column
        v-if="checkShouldTableColumnShow('appUser.accountNm')"
        :label="$t('주문자')"
        prop="appUser.accountNm"
        min-width="100"
        align="center"></el-table-column>
      <el-table-column
        v-if="checkShouldTableColumnShow('salesTp.nmLan')"
        :label="$t('판매 방식')"
        prop="salesTp.nmLan"
        min-width="80"
        align="center"
        sortable="custom"></el-table-column>
      <el-table-column
        v-if="checkShouldTableColumnShow('pickUpTime')"
        :label="$t('픽업 예정 시간')"
        prop="pickUpTime"
        min-width="110"
        align="center"
        sortable="custom">
        <template slot-scope="scope"
          >{{ scope.row.pickUpTime }}&nbsp;<span>{{ $t('분') }}</span></template
        >
      </el-table-column>
      <el-table-column
        v-if="checkShouldTableColumnShow('orderStatus.nmLan')"
        :label="$t('주문 상태')"
        prop="orderStatus.nmLan"
        min-width="80"
        align="center"
        sortable="custom"></el-table-column>
      <el-table-column
        v-if="checkShouldTableColumnShow('payYn')"
        :label="$t('결제 여부')"
        prop="payYn"
        min-width="80"
        align="center"
        sortable="custom"
        :formatter="mainVue.formatterCode"></el-table-column>
      <el-table-column
        v-if="checkShouldTableColumnShow('deliveryCost')"
        :label="$t('배달비')"
        prop="deliveryCost"
        min-width="80"
        align="right"
        :formatter="mainVue.formatterPrice"></el-table-column>
      <el-table-column
        v-if="checkShouldTableColumnShow('amt')"
        :label="$t('총금액')"
        prop="amt"
        min-width="80"
        align="right"
        sortable="custom"
        :formatter="mainVue.formatterPrice"></el-table-column>
      <el-table-column
        v-if="checkShouldTableColumnShow('discountNms')"
        :label="$t('할인 정보')"
        prop="discountNms"
        min-width="150"
        show-overflow-tooltip></el-table-column>
      <el-table-column
        v-if="checkShouldTableColumnShow('orderDesc')"
        :label="$t('주문 설명')"
        prop="orderDesc"
        min-width="300"
        show-overflow-tooltip></el-table-column>

      <el-table-column
        v-if="checkShouldTableColumnShow('orderDelivery.deliveryCode')"
        :label="$t('배달업체코드')"
        prop="orderDelivery.deliveryCode"
        min-width="150"
        show-overflow-tooltip></el-table-column>
      <el-table-column
        v-if="checkShouldTableColumnShow('orderDelivery.deliveryName')"
        :label="$t('배달업체명')"
        prop="orderDelivery.deliveryName"
        min-width="150"
        show-overflow-tooltip></el-table-column>
      <el-table-column
        v-if="checkShouldTableColumnShow('orderDelivery.deliveryId')"
        :label="$t('배송번호')"
        prop="orderDelivery.deliveryId"
        min-width="150"
        show-overflow-tooltip></el-table-column>
      <el-table-column
        v-if="checkShouldTableColumnShow('orderDelivery.posOrderCode')"
        :label="$t('주문번호')"
        prop="orderDelivery.posOrderCode"
        min-width="150"
        show-overflow-tooltip></el-table-column>
      <el-table-column
        v-if="checkShouldTableColumnShow('orderDelivery.posStoreCode')"
        :label="$t('가맹점 코드')"
        prop="orderDelivery.posStoreCode"
        min-width="150"
        show-overflow-tooltip></el-table-column>
      <el-table-column
        v-if="checkShouldTableColumnShow('orderDelivery.resultTime')"
        :label="$t('상태 변경')"
        prop="orderDelivery.resultTime"
        min-width="150"
        show-overflow-tooltip></el-table-column>
      <el-table-column
        v-if="checkShouldTableColumnShow('orderDelivery.riderName')"
        :label="$t('라이더 이름')"
        prop="orderDelivery.riderName"
        min-width="150"
        show-overflow-tooltip></el-table-column>
      <el-table-column
        v-if="checkShouldTableColumnShow('orderDelivery.riderTel')"
        :label="$t('전화번호')"
        prop="orderDelivery.riderTel"
        :formatter="util.telCell"
        min-width="150"
        show-overflow-tooltip></el-table-column>
      <el-table-column
        v-if="checkShouldTableColumnShow('orderDelivery.cardAuthNum')"
        :label="$t('승인코드')"
        prop="orderDelivery.cardAuthNum"
        min-width="150"
        show-overflow-tooltip></el-table-column>
      <el-table-column
        v-if="checkShouldTableColumnShow('orderDelivery.cardCodeName')"
        :label="$t('매입사명')"
        prop="orderDelivery.cardCodeName"
        min-width="150"
        show-overflow-tooltip></el-table-column>
      <el-table-column
        v-if="checkShouldTableColumnShow('orderDelivery.cardAuthDate')"
        :label="$t('승인일자')"
        prop="orderDelivery.cardAuthDate"
        min-width="150"
        show-overflow-tooltip></el-table-column>
      <el-table-column
        v-if="checkShouldTableColumnShow('orderDelivery.cardCost')"
        :label="$t('승인금액')"
        prop="orderDelivery.cardCost"
        min-width="150"
        align="right"
        show-overflow-tooltip></el-table-column>
    </el-table>

    <!-- 페이징 -->
    <list-pagination
      :search-form="searchForm"
      :total="totalElements"
      @page-change="handlePageChange"
      @size-change="handleSizeChange"></list-pagination>

    <!-- 배달 요청 팝업 -->
    <el-dialog :title="$t('배달요청')" :visible.sync="dialogFormVisible" width="900px" :modal="false">
      <el-form
        :model="inputForm"
        :label-width="$device.tablet ? `` : `120px`"
        label-suffix=":"
        :size="size"
        @submit.native.prevent>
        <el-row>
          <el-col :span="8">
            <el-form-item :label="$t('배달대행')">
              <el-select v-model="deliveryCode">
                <el-option
                  v-for="item in deliverys"
                  :key="item.deliveryCode"
                  :label="item.deliveryName"
                  :value="item.deliveryCode"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item :label="$t('거리')">
              <el-input v-model="selectOrderData.delivery_distance" :disabled="true"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item :label="$t('받을금액')">
              <el-input v-model="selectOrderData.showAmt" :disabled="true"></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="16">
            <el-form-item :label="$t('위치설명')">
              <el-input v-model="selectOrderData.orderAddr"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item :label="$t('전화')">
              <el-input :value="telText(selectOrderData.tel)" :disabled="true"></el-input>
            </el-form-item>
          </el-col>

          <el-col :span="24">
            <el-form-item :label="$t('메뉴')">
              <el-input v-model="selectOrderData.menus" :disabled="true"></el-input>
            </el-form-item>
          </el-col>

          <el-col :span="24">
            <el-button
              icon="el-icon-check"
              :size="size"
              @click="calculateDeliveryCost"
              style="float: right; margin-bottom: 10px"
              >{{ $t('배송비 계산') }}</el-button
            >
          </el-col>

          <el-col :span="8">
            <el-form-item :label="$t('배송비')">
              <el-input v-model="selectOrderData.delivery_fee" :disabled="true"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item :label="$t('기본')">
              <el-input v-model="selectOrderData.delivery_com" :disabled="true"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item :label="$t('할증')">
              <el-input v-model="selectOrderData.delivery_extra" :disabled="true"></el-input>
            </el-form-item>
          </el-col>

          <el-col :span="24">
            <el-form-item :label="$t('상점도착 요청시간')" label-width="180px">
              <el-select v-model="selectOrderData.pick_min">
                <el-option v-for="item in selectOrderData.pick_lst" :key="item" :label="item" :value="item"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>

      <div slot="footer" class="dialog-footer">
        <el-button
          icon="el-icon-bicycle"
          :size="size"
          @click="callDelivery(2, false)"
          v-show="'Y' == selectOrderData.payYn && !util.isEmpty(selectOrderData.delivery_fee)"
          >{{ $t('배달요청 선결제') }}</el-button
        >

        <el-button
          icon="el-icon-bicycle"
          :size="size"
          @click="callDelivery(1, false)"
          v-show="
            'N' == selectOrderData.payYn &&
            '카드' == selectOrderData.payDiv &&
            !util.isEmpty(selectOrderData.delivery_fee)
          "
          >{{ $t('배달요청 카드') }}</el-button
        >

        <el-button
          icon="el-icon-bicycle"
          :size="size"
          @click="callDelivery(0, false)"
          v-show="
            'N' == selectOrderData.payYn &&
            '현금' == selectOrderData.payDiv &&
            !util.isEmpty(selectOrderData.delivery_fee)
          "
          >{{ $t('배달요청 현금') }}</el-button
        >

        <el-button
          icon="el-icon-close"
          :size="size"
          @click="callDelivery(-1, true)"
          v-show="!util.isEmpty(selectOrderData.orderDelivery)"
          >{{ $t('배달요청 삭제') }}</el-button
        >

        <el-button icon="el-icon-close" :size="size" @click="dialogFormVisible = false">{{ $t('닫기') }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import OrderRefundStatus from '@/components/order/list/OrderRefundStatus.vue'
import TableFieldCombo from '@/components/order/list/TableFieldCombo.vue'
import mainVueMixin from '@/mixins/mainVueMixin'
import pagedListMixin from '@/mixins/pagedListMixin'
import { util } from '@/mixins/utilMixin'
import { initData } from '@/utils/constants'
import {
  ORDER_REFUND_TEXT,
  cancelActorLabel,
  deliveryCallCancelNotice,
  hasCancelledRow,
  orderListQuery,
} from '@/utils/orderRefund'
import { pagingQuery, withPaging } from '@/utils/pagedList'
import { telText } from '@/utils/telNumber'

/**
 * 중첩 값을 그리는 정렬 열의 `prop` → 서버 `sortProp`(화이트리스트 이름).
 *
 * 서버가 정렬하는 것은 두 축 모두 `sys_code.nm` — 사람이 보는 그 이름이다. 코드순이 아니다.
 */
const SORT_ALIASES = Object.freeze({
  'salesTp.nmLan': 'salesTp',
  'orderStatus.nmLan': 'orderStatus',
})

export default {
  mixins: [mainVueMixin, pagedListMixin],

  components: { OrderRefundStatus, TableFieldCombo },

  data: function () {
    var data = initData()
    data.url = '/order'
    data.searchForm = this.initSearchForm()
    data.sedtm = [
      util.getDate('yyyy-MM-dd HH:mm:ss', util.dateAdd('d ', -2, new Date())),
      util.getDate('yyyy-MM-dd HH:mm:ss', new Date()),
    ]

    data.orderStatus = []
    data.orderStatusCds = []

    data.refundText = ORDER_REFUND_TEXT

    data.expand = false

    data.autoSearch = false

    // 배달 대행 관련
    data.dialogFormVisible = false
    data.deliverys = []
    data.deliveryCode = null
    data.selectOrderData = {
      tel: '',
      menus: '',
      pick_min: 1,
      showAmt: '',
      addressObj: null,
      delivery_fee: 0,
    }

    return data
  },
  created: function () {
    this.initOrderStatus()
    // 자동 검색 설정
    this.autoSearch = 'true' == util.getCookie('autoSearch') ? true : false

    this.searchDelivery()
  },
  mounted: function () {
    setTimeout(
      function () {
        this.$nextTick(
          function () {
            // this.mainVue.currVue = this
          }.bind(this)
        )

        // this.mainVue.orderAutoSearch = this.orderAutoSearch
      }.bind(this),
      500
    )
  },
  computed: {
    /** 중첩 열의 정렬 축 — 기본 `{}` 를 주는 [pagedListMixin] 의 같은 이름을 덮어쓴다 */
    sortAliases: function () {
      return SORT_ALIASES
    },
    /** 취소·환불 칸 — 받은 행에 취소된 주문이 있을 때만 */
    showsCancelColumns: function () {
      return hasCancelledRow(this.tableData)
    },
  },
  watch: {
    autoSearch: function (oldVal, newVal) {
      util.setCookie('autoSearch', this.autoSearch, 365)
    },
  },
  methods: {
    /** 다 친 번호의 표기 — 번호 종류로 끊는다(`utils/telNumber`) */
    telText,

    // 검색 조건 초기화 — 페이징·정렬 축은 [withPaging] 이 붙인다(서버 기본 정렬 = 주문 시간 오름차순)
    initSearchForm: function () {
      return withPaging({
        autoEdtm: true,
        startDate: null,
        endDate: null,
        orderStatusCds: '',
        cancelYn: 'N',
        cancelPay: 'N',
        // 「환불 실패만」 — 켜면 조회가 `refundPending=true` 를 싣고 취소 축을 비운다(`utils/orderRefund.orderListQuery`)
        refundPending: false,
      })
    },
    /** 서버로 보낼 검색 조건 — 페이징 축([pagingQuery]) 위에 「환불 실패만」을 번역한다. 믹스인의 같은 이름을 덮어쓴다 */
    searchQuery: function () {
      return orderListQuery(pagingQuery(this.searchForm))
    },
    cancelActorLabel,
    // 그리드 선택 이벤트
    handleRowClick: function (val) {
      this.selectData = val
      this.$refs.table.toggleRowExpansion(val, true)
    },
    // 그리드 두번 클릭 이벤트
    handleRowDbClick: function (val) {
      this.$refs.table.toggleRowExpansion(val, false)
    },
    handleExpand: function () {
      this.expand = !this.expand

      for (var i = 0, len = this.$refs.table.tableData.length; i < len; i++) {
        this.$refs.table.toggleRowExpansion(this.$refs.table.tableData[i], this.expand)
      }
    },
    // 체크 박스 체크 이벤트
    handleRowChecked: function (selection, row) {
      if (selection.length > 0) {
        this.btn.delDisabled = false
      } else {
        this.btn.delDisabled = true
      }

      this.checkedData = []

      for (var i = 0, len = selection.length; i < len; i++) {
        this.checkedData[this.checkedData.length] = selection[i].orderCd
      }
    },
    // 주문 상태 데이타 초기화
    initOrderStatus: function () {
      this.mainVue.$axios.search(
        '/code/getCode/ORDER_STATUS',
        null,
        function (result) {
          this.orderStatus = result

          // 기본 건색 상태 설정
          for (var i = 0, len = this.orderStatus.length; i < len; i++) {
            if ('OVER' != this.orderStatus[i].val) {
              this.orderStatusCds.push(this.orderStatus[i])
            }
          }
        }.bind(this)
      )
    },
    /**
     * 기간이 골라져 있는가 — 없으면 안내하고 거짓이다. 이 조회의 **전제**라 판정을 한 곳에 둔다.
     */
    checkPeriod: function () {
      if (null == this.sedtm || this.sedtm.length < 2) {
        this.mainVue.$message({ type: 'success', message: this.$t('기간을 선택 하여 주십시오.') })

        return false
      }

      return true
    },
    /**
     * 검색 버튼 — **기간을 먼저 보고** 조회할 수 있을 때만 1페이지로 되돌린다.
     *
     * 순서가 반대면(먼저 1페이지로 내리고 `search()` 가 기간에서 되돌아가면) 아무것도 묻지 않았는데
     * 보고 있던 3페이지만 사라진다. 사람은 안내 문구를 닫고 나서 다른 표를 보게 된다.
     */
    searchWithPeriod: function () {
      if (!this.checkPeriod()) return

      this.searchFirstPage()
    },
    /**
     * 조회 — **현재 페이지·정렬을 유지한다**.
     *
     * 이 메서드는 검색 버튼만 부르는 것이 아니다: 주문통지 자동 재조회([orderAutoSearch])와 상태 변경·
     * 주문 취소·배달 요청의 뒤처리가 모두 부른다. 그때 1페이지로 돌아가면 3페이지에서 한 건을 접수한
     * 사람이 매번 맨 앞으로 끌려간다. 조건이 바뀐 조회는 `searchFirstPage`(검색 버튼)다.
     */
    search: function () {
      if (!this.checkPeriod()) return

      this.searchForm.startDate = this.sedtm[0]

      if (this.searchForm.autoEdtm) {
        this.sedtm = [this.sedtm[0], util.getDate('yyyy-MM-dd HH:mm:ss', new Date())]
      }

      this.searchForm.endDate = this.sedtm[1]

      var tmp = []
      for (var i = 0, len = this.orderStatusCds.length; i < len; i++) {
        tmp.push(this.orderStatusCds[i].cd)
      }

      this.searchForm.orderStatusCds = tmp.join(',')

      this.mainVue.$axios.search(
        this.url,
        this.searchQuery(),
        function (result) {
          this.applyPage(result)
        }.bind(this)
      )
    },
    // 주문 취소
    del: function (orderCd, orderSeq) {
      this.mainVue
        .$confirm(
          this.$t('주문 취소하시겠습니까? 이미 결제된 주문은 자동 환불 처리 됩니다.'),
          this.mainVue.appMsg.systemAlterTitle,
          {
            confirmButtonText: this.$t('주문 취소'),
            cancelButtonText: this.$t('취소'),
            type: 'info',
          }
        )
        .then(
          function () {
            this.mainVue.$axios.del(
              this.url + (!util.isEmpty(orderCd) ? '/' + orderCd : '/text/' + orderSeq),
              function (result) {
                this.afterCancel(deliveryCallCancelNotice(result))
              }.bind(this)
            )
          }.bind(this)
        )
        .catch(
          function () {
            this.mainVue.$message({ type: 'info', message: this.$t('취소 성공') })
          }.bind(this)
        )
    },
    /**
     * 주문 취소가 끝난 뒤 — 배달대행 안내(`utils/orderRefund.deliveryCallCancelNotice`)대로 말하고 목록을 다시 읽는다(현재 페이지
     * 유지). 문장은 서버 것이다.
     *
     * - 배달대행 호출을 취소하지 못했다(`failed`) — 매장이 전화나 대행 앱으로 직접 취소해야 하는 말이라 사라지는 토스트가 아니라
     *   확인창이고, 닫은 뒤에 다시 읽는다.
     * - 함께 취소했다 — 그 문장을 성공 안내로.
     * - 업체를 부르지 않은 취소(`null`) — 종전 「주문 취소 성공」.
     *
     * @param {?{failed: boolean, message: string}} notice
     */
    afterCancel: function (notice) {
      if (notice && notice.failed) {
        this.$alert(notice.message, this.mainVue.appMsg.systemAlterTitle, {
          type: 'warning',
          // 콜백을 주면 확인창의 약속(Promise)이 거절되지 않는다 — 닫기(×)도 확인처럼 여기로 온다
          callback: () => this.search(),
        })
        return
      }

      this.mainVue.$message({ type: 'success', message: notice ? notice.message : this.$t('주문 취소 성공') })
      this.search()
    },
    // 결제 취소
    cancelPay: function (orderCd) {
      this.mainVue
        .$confirm(this.$t('결제 취소하시겠습니까?'), this.mainVue.appMsg.systemAlterTitle, {
          confirmButtonText: this.$t('결제 취소'),
          cancelButtonText: this.$t('취소'),
          type: 'info',
        })
        .then(
          function () {
            this.mainVue.$axios.del(
              this.url + '/cancelPay/' + orderCd,
              function (result) {
                this.mainVue.$message({ type: 'success', message: this.$t('결제 취소 성공') })
                this.search()
              }.bind(this)
            )
          }.bind(this)
        )
        .catch(
          function () {
            this.mainVue.$message({ type: 'info', message: this.$t('취소 성공') })
          }.bind(this)
        )
    },
    // 주문 상태 변경
    changeOrderStatus: function (row, orderStatusVal) {
      this.mainVue.$axios.patch(
        this.url +
          '/status/' +
          (!util.isEmpty(row.orderCd) ? row.orderCd : 'text/' + row.orderSeq) +
          '/' +
          orderStatusVal,
        null,
        null,
        function (result) {
          this.mainVue.$message({ type: 'success', message: this.$t('처리 되었습니다.') })
          this.search()
        }.bind(this)
      )
    },
    // 주문 자동 검색 함수
    /**
     * 주문통지 자동 재조회 — **사람이 고른 조건은 건드리지 않는다**.
     *
     * 종전에는 여기서 `cancelYn` 을 `'N'` 으로 덮었다. 「취소 포함」으로 보고 있던 사람의 화면이
     * 알림 한 번에 조용히 「취소 제외」로 바뀌는 셈이라, 사라진 행을 사람이 찾게 된다.
     * (현재 이 메서드를 부르는 곳은 없다 — 웹소켓 배선이 주석 처리돼 있다.)
     */
    orderAutoSearch: function () {
      if (this.autoSearch) {
        this.search()
      }
    },
    // 알림톡 발송
    send: function (orderCd, orderSeq) {
      this.mainVue.$axios.patch(
        this.url + '/send/' + (!util.isEmpty(orderCd) ? orderCd : 'text/' + orderSeq),
        null,
        null,
        function (result) {
          this.mainVue.$message({ type: 'success', message: this.$t('알림톡 발송 되었습니다.') })
        }.bind(this)
      )
    },
    // 배달대행 업체 리스트 조회
    searchDelivery: function () {
      this.deliverys = []
      this.deliveryCode = null

      // this.mainVue.$axios.search(
      //   '/delivery/store/get',
      //   null,
      //   function (result) {
      //     this.deliverys = result
      //
      //     if (this.deliverys.length > 0) {
      //       this.deliveryCode = this.deliverys[0].deliveryCode
      //     }
      //   }.bind(this)
      // )
    },
    // 배달 팝업
    delivery: function (row) {
      this.dialogFormVisible = true
      this.selectOrderData = row

      // 받을 금액 설정
      this.selectOrderData.showAmt = util.formatMoney(this.selectOrderData.amt)
      // 메뉴 표시
      this.selectOrderData.menus = ''

      this.selectOrderData.smenus.forEach((smenu) => {
        if ('' == this.selectOrderData.menus) {
          this.selectOrderData.menus += smenu.smenuNmLan
        } else {
          this.selectOrderData.menus += ', ' + smenu.smenuNmLan
        }
      })

      // 카카오 API로 도로명, 지번 주소 조회 하기, 주소 짤라서 사용은 불가능함
      // 주소로 좌표를 검색합니다
      new kakao.maps.services.Geocoder().addressSearch(
        this.selectOrderData.orderAddr,
        function (result, status) {
          // 정상적으로 검색이 완료됐으면
          if (status === kakao.maps.services.Status.OK) {
            this.selectOrderData.addressObj = result[0]
          } else {
          }
        }.bind(this)
      )
    },
    calculateDeliveryCost: function () {
      // 상세 주소 설정
      var dest_Detail_addr = this.selectOrderData.orderAddr.split(
        this.selectOrderData.addressObj.address_name.substring(8)
      )

      if (dest_Detail_addr.length > 1) {
        dest_Detail_addr = dest_Detail_addr[1].replace('[', '').replace(']', '')
      } else {
        dest_Detail_addr = this.selectOrderData.orderAddr.split(' ')

        dest_Detail_addr =
          dest_Detail_addr[dest_Detail_addr.length - 2].replace('[', '').replace(']', '') +
          dest_Detail_addr[dest_Detail_addr.length - 1].replace('[', '').replace(']', '')
      }

      var params = {
        request_id:
          (util.isEmpty(this.selectOrderData.orderCd) ? this.selectOrderData.orderSeq : this.selectOrderData.orderCd) +
          '_' +
          this.selectOrderData.orderId,
        delivery_code: this.deliveryCode,
        dest_sido: this.selectOrderData.addressObj.road_address.region_1depth_name,
        dest_sigungu: this.selectOrderData.addressObj.address.region_2depth_name,
        dest_legal_eupmyeondong: this.selectOrderData.addressObj.address.region_3depth_name,
        dest_admin_eupmyeondong: this.selectOrderData.addressObj.address.region_3depth_h_name,
        dest_ri: '',
        dest_beonji: this.selectOrderData.addressObj.address.main_address_no,
        dest_road: this.selectOrderData.addressObj.road_address.road_name,
        dest_building_number: this.selectOrderData.addressObj.road_address.main_building_no,
        dest_Detail_addr: dest_Detail_addr,
        dest_memo: this.selectOrderData.orderDesc,
        dest_lat: this.selectOrderData.addressObj.address.y,
        dest_lng: this.selectOrderData.addressObj.address.x,
        pay_amt: this.selectOrderData.amt,
      }

      this.mainVue.$axios.search(
        '/delivery/store/orderfee',
        params,
        function (result) {
          if ('0000' != result.result_code) {
            this.mainVue.$message({ type: 'warning', message: result.result_message })
            return
          }

          if ('N' == result.is_run) {
            this.mainVue.$message({ type: 'warning', message: this.$t('배달 불 가능한 주소입니다.') })
            return
          }

          this.selectOrderData.delivery_distance = result.delivery_distance
          this.selectOrderData.pick_lst = result.pick_lst.split('/')
          this.selectOrderData.pick_min = this.selectOrderData.pick_lst[0]

          this.selectOrderData.delivery_fee = result.delivery_fee
          this.selectOrderData.delivery_extra =
            parseInt(result.extra_addr) +
            parseInt(result.extra_distance) +
            parseInt(result.extra_price) +
            parseInt(result.extra_rain) +
            parseInt(result.extra_snow) +
            parseInt(result.extra_freeze) +
            parseInt(result.extra_weekend) +
            parseInt(result.extra_holiday) +
            parseInt(result.extra_busytime) +
            parseInt(result.extra_night)

          Vue.set(
            this.selectOrderData,
            'delivery_com',
            this.selectOrderData.delivery_fee - this.selectOrderData.delivery_extra
          )
        }.bind(this)
      )
    },
    // 배달 요청
    callDelivery: function (pay_type, idDel) {
      var type = 'neworder'
      var delivery_id = ''

      if (!util.isEmpty(this.selectOrderData.orderDelivery)) {
        type = 'editorder'
        delivery_id = this.selectOrderData.orderDelivery.deliveryId
      }

      if (idDel) {
        type = 'deleteorder'
        delivery_id = this.selectOrderData.orderDelivery.deliveryId
      }

      var dest_Detail_addr = this.selectOrderData.orderAddr
        .replace(this.selectOrderData.addressObj.address_name, '')
        .trim()
      dest_Detail_addr = dest_Detail_addr.replace('[', '').replace(']', '')

      var params = {
        type: type,
        pay_type: pay_type,
        orderCd: this.selectOrderData.orderCd,
        orderSeq: this.selectOrderData.orderSeq,
        orderId: this.selectOrderData.orderId,
        delivery_id: delivery_id,
        delivery_code: this.deliveryCode,
        delivery_name: this.deliverys.filter((delivery) => delivery.deliveryCode == this.deliveryCode)[0].deliveryName,
        dest_sido: this.selectOrderData.addressObj.road_address.region_1depth_name,
        dest_sigungu: this.selectOrderData.addressObj.address.region_2depth_name,
        dest_legal_eupmyeondong: this.selectOrderData.addressObj.address.region_3depth_name,
        dest_admin_eupmyeondong: this.selectOrderData.addressObj.address.region_3depth_h_name,
        dest_ri: '',
        dest_beonji: this.selectOrderData.addressObj.address.main_address_no,
        dest_road: this.selectOrderData.addressObj.road_address.road_name,
        dest_building_number: this.selectOrderData.addressObj.road_address.main_building_no,
        dest_Detail_addr: dest_Detail_addr,
        dest_memo: this.selectOrderData.orderDesc,
        dest_lat: this.selectOrderData.addressObj.address.y,
        dest_lng: this.selectOrderData.addressObj.address.x,
        pay_amt: this.selectOrderData.amt,
        pick_min: this.selectOrderData.pick_min,
        tel: this.selectOrderData.tel,
        order_note: this.selectOrderData.orderDesc,
      }

      this.mainVue.$axios.post(
        '/delivery/call/order',
        params,
        function (result) {
          if ('0000' != result.result_code) {
            this.mainVue.$message({ type: 'warning', message: result.result_message })
            return
          }

          this.dialogFormVisible = false
          this.search()
        }.bind(this)
      )
    },
    showDeliveryStatus: function (orderDelivery) {
      var result = ''

      if (!util.isEmpty(orderDelivery)) {
        switch (orderDelivery.stateCode) {
          case '-1':
            result = '취소요청'
            break
          case '0':
            result = '배달요청'
            break
          case '1':
            result = '요청접수'
            break
          case '2':
            result = '기사배정'
            break
          case '3':
            result = '기사픽업'
            break
          case '5':
            result = '배달완료'
            break
          case '44':
            result = '배달사취소'
            break
          default:
            result = '미요청'
        }
      }

      return result
    },
    checkShouldTableColumnShow(key) {
      const columns = this.$store.getters['ui/orderListTableFields']

      return columns.includes(key)
    },
  },
}
</script>

<style scoped>
.order-list__refund {
  margin-left: 12px;
}
.el-card {
  max-width: 800px;
  margin-bottom: 10px;
}
.el-card__header,
.el-card__body {
  padding: 10px 20px;
}
.el-col-num {
  text-align: right;
}

.el-form-item::v-deep .el-form-item__content {
  min-height: 55px;

  white-space: nowrap;
}

@media (max-width: 768px) {
  .el-form-item::v-deep .el-form-item__content {
    min-height: unset;

    white-space: unset;
  }
}
</style>
